import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {injectIntl} from 'react-intl';
import {Link} from 'react-router';
import classNames from 'classnames';

import {pathByLabel} from '../utils/urlPaths';

export {PATHS} from '../utils/urlPaths';

export function bindPaths(...args) {
  const links = {};

  args.forEach(arg => {
    const argType = typeof arg;

    if (argType === 'string') {
      links[arg] = true;
    } else if (argType === 'object') {
      Object.entries(links).forEach(([key, val]) => {
        if (val) links[key] = true;
      });
    }
  });

  return links;
}

class Footer extends Component {
  getPrintableLinks() {
    const {links} = this.props;
    const printableLinks = [];

    Object.entries(links).forEach(([key, val]) => {
      if (val) printableLinks.push(key);
    });

    return printableLinks;
  }

  render() {
    const {
      intl,
      appearance,
      xl: {compactView}
    } = this.props;
    const printableLinks = this.getPrintableLinks();

    return (
      <div
        className={classNames('footer', `footer--${appearance}`, {'footer--small': compactView})}
      >
        <ul className="footer-links">
          {printableLinks.map(link => (
            <li key={link}>
              <Link
                id={`footer_${link}`}
                to={{
                  pathname: pathByLabel[link],
                  search: this.context.location.search
                }}
              >
                {intl.messages[`footer.${link}`]}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

Footer.defaultProps = {
  links: {},
  appearance: 'bottom'
};

Footer.propTypes = {
  links: PropTypes.objectOf(PropTypes.bool),
  intl: PropTypes.object,
  xl: PropTypes.object.isRequired,
  appearance: PropTypes.string
};

Footer.contextTypes = {
  location: PropTypes.object
};

export default injectIntl(connect(state => state)(Footer));



// WEBPACK FOOTER //
// ./components/Footer.jsx